<template>
  <div :class="['c-button__container', { 'c-open': isActive }, { 'c-padding': givePadding }]">
    <button :id="buttonId" @click="click" type="submit" class="c-button" :disabled="disabled == true">
     <span> {{ text || 'Beregn' }}</span>
    </button>
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'Button',
  data() {
    return {
      stepNext: this.dataStepNext ? this.dataStepNext : 0
    };
  },
  props: {
    text: String,
    dataStepNext: Number,
    isActive: Boolean,
    givePadding: Boolean,
    disabled: Boolean,
    buttonId: String
  },
  mounted () {
    if (this.buttonId == '') {
      this.buttonId = this._uid + "-button"
    }
  },
  methods: {
    click() {
      this.$emit('childToParent', this.stepNext);
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './button';
</style>
